import { isInternetExplorer } from './browser-detect';
var TabsLoader = /** @class */ (function () {
    function TabsLoader() {
        this.tabsClassName = 'js-tabs';
        var tabs = document.getElementsByClassName(this.tabsClassName);
        // Create for each js-class that is found a new instance of class TabsContainer.
        // But don't create it, if data-tabs-autoload="false" is set.
        // This is for tabs used in vue components, that need to call methods.
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (!tab.dataset.tabsAutoload || tab.dataset.tabsAutoload !== 'false') {
                new TabsContainer(tab);
            }
        }
    }
    return TabsLoader;
}());
export default TabsLoader;
var TabsContainer = /** @class */ (function () {
    function TabsContainer(tabs) {
        this.contentContainerClass = 'js-tabs-content';
        this.contentItemsClass = 'js-tabs-content-item';
        this.tabInputClass = 'js-tabs-input';
        this.linkClass = 'js-tabs-label';
        this.navWrapperClass = 'js-tabs-nav-wrapper';
        this.navClass = 'js-tabs-nav';
        this.sliderClass = 'js-tabs-slider';
        this.scrollToContainerClass = 'js-tabs-scroll-to-container';
        this.scrollIntoView = true;
        this.startToScrollOffset = 12; //start scrolling even if the item is visible to prevent hiding more items on the left side
        this.scrollOffset = 18; // scroll a bit more than the item width to teaser siblings
        this.activeIndex = 0;
        this.resizeTimeout = 0;
        this.transitionTimeout = 0;
        this.contentContainer = tabs.getElementsByClassName(this.contentContainerClass)[0];
        this.contentItems = this.contentContainer.getElementsByClassName(this.contentItemsClass);
        this.inputs = tabs.getElementsByClassName(this.tabInputClass);
        this.labels = tabs.getElementsByClassName(this.linkClass);
        this.nav = tabs.getElementsByClassName(this.navClass)[0];
        this.navWrapper = tabs.getElementsByClassName(this.navWrapperClass)[0];
        this.slider = tabs.getElementsByClassName(this.sliderClass)[0];
        this.scrollToContainer = document.getElementsByClassName(this.scrollToContainerClass)[0];
        this.tabs = tabs;
        this.tabsCount = this.contentContainer.children.length;
        this.that = this;
        this.scrollIntoView = this.setScrollIntoView();
        this.activeIndex = this.getActiveIndex();
        this.init();
    }
    TabsContainer.prototype.bindEvents = function () {
        var _this = this;
        this.bindLabelClick();
        this.bindInputClick();
        //this.bindNavWrapperScrollEvent();
        window.addEventListener('resize', function () { _this.onResize(); });
    };
    TabsContainer.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.setInitialSliderStyle();
        }, 300);
    };
    TabsContainer.prototype.setInitialSliderStyle = function () {
        var activeRadioButton = this.tabs.querySelectorAll('.js-tabs > :checked')[0];
        var activeLabel = this.labels[0];
        if (activeRadioButton) {
            // If an active radio button is found (e.g. from browser cache), take it -
            // otherwise always take the first label for setting the initial slider styles
            activeLabel = this.tabs.querySelectorAll('label[for="' + activeRadioButton.id + '"]')[0];
        }
        this.setSliderStyle(activeLabel.getBoundingClientRect().width, activeLabel.getBoundingClientRect().left - this.nav.getBoundingClientRect().left);
    };
    TabsContainer.prototype.setSliderStyle = function (width, left) {
        var sliderWidth = width + 'px';
        var sliderPositionLeft = left + 'px';
        this.slider.setAttribute('style', 'width: ' + sliderWidth + '; left: ' + sliderPositionLeft + ';');
    };
    TabsContainer.prototype.scrollContentToTop = function () {
        var _a;
        (_a = document.getElementsByClassName(this.scrollToContainerClass)[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    TabsContainer.prototype.bindLabelClick = function () {
        var _this = this;
        var _loop_1 = function (i) {
            this_1.labels[i].addEventListener('click', function () {
                var label = _this.labels[i];
                if (_this.scrollIntoView) {
                    _this.scrollElementIntoView(label);
                }
                _this.setSliderStyle(label.getBoundingClientRect().width, label.getBoundingClientRect().left - _this.nav.getBoundingClientRect().left + _this.nav.scrollLeft);
                _this.scrollContentToTop();
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.labels.length; i++) {
            _loop_1(i);
        }
    };
    TabsContainer.prototype.bindInputClick = function () {
        var _this = this;
        if (!this.contentItems.length) {
            return false;
        }
        var _loop_2 = function (item) {
            var tabLink = this_2.inputs[item];
            tabLink.addEventListener('click', function () {
                _this.getActiveTabContent(item, _this.activeIndex, _this.inputs.length);
                _this.activeIndex = item;
            });
        };
        var this_2 = this;
        for (var item = 0; item < this.inputs.length; item++) {
            _loop_2(item);
        }
    };
    TabsContainer.prototype.bindNavWrapperScrollEvent = function () {
        var _this = this;
        var scrollTimeout = 0;
        this.navWrapper.addEventListener('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                _this.scrollContentToTop();
            }, 100);
        });
    };
    TabsContainer.prototype.getActiveIndex = function () {
        var contentItems = Array.from(this.contentItems);
        return contentItems.findIndex(function (contentItem) { return contentItem.classList.contains('is-active'); });
    };
    TabsContainer.prototype.getActiveTabContent = function (itemIndex, lastActiveItem, inputItems, noAnimation) {
        if (noAnimation === void 0) { noAnimation = false; }
        if (itemIndex !== lastActiveItem && itemIndex >= 0) {
            this.resetDirections(itemIndex);
            this.setCurrentActiveItem(itemIndex, noAnimation);
            this.removeLastActiveItem(lastActiveItem, noAnimation);
            if (lastActiveItem < itemIndex) {
                this.handleTabItems('left', 0, itemIndex);
            }
            else if (lastActiveItem > itemIndex) {
                this.handleTabItems('right', inputItems - 1, itemIndex);
            }
        }
    };
    TabsContainer.prototype.handleTabItems = function (direction, from, until) {
        var count = from;
        if (direction === 'left') {
            for (count; count < until; count++) {
                this.removeDirectionRight(count);
                this.addDirectionLeft(count);
            }
        }
        else {
            for (count; count > until; count--) {
                this.removeDirectionLeft(count);
                this.addDirectionRight(count);
            }
        }
    };
    TabsContainer.prototype.init = function () {
        this.bindEvents();
        this.setInitialSliderStyle();
        var lastActiveItem = this.activeIndex > 0 ? (this.activeIndex - 1) : 0;
        this.getActiveTabContent(this.activeIndex, lastActiveItem, this.inputs.length, true);
    };
    TabsContainer.prototype.isOnLeftSideInViewport = function (tabItem) {
        return tabItem.getBoundingClientRect().left >= this.startToScrollOffset;
    };
    TabsContainer.prototype.isOnRightSideInViewport = function (tabItem) {
        return tabItem.getBoundingClientRect().right <= this.nav.getBoundingClientRect().width - this.scrollOffset;
    };
    TabsContainer.prototype.scrollElementIntoView = function (tabItem) {
        var scrollLeft = 0;
        var needScrolling = false;
        if (!this.isOnRightSideInViewport(tabItem)) {
            scrollLeft = tabItem.getBoundingClientRect().right;
            needScrolling = true;
        }
        else if (!this.isOnLeftSideInViewport(tabItem)) {
            scrollLeft = tabItem.getBoundingClientRect().left;
            needScrolling = true;
        }
        if (needScrolling) {
            this.navWrapper.scroll({
                left: scrollLeft,
                behavior: 'smooth'
            });
        }
    };
    TabsContainer.prototype.setScrollIntoView = function () {
        var scrollAttribute = this.tabs.getAttribute('data-tabs-scroll');
        return scrollAttribute ? (scrollAttribute === 'true') : this.scrollIntoView;
    };
    TabsContainer.prototype.addActiveItem = function (index) {
        this.contentItems[index].classList.add('is-active');
    };
    TabsContainer.prototype.removeActiveItem = function (index) {
        this.contentItems[index].classList.remove('is-active');
    };
    TabsContainer.prototype.removeDirectionLeft = function (index) {
        this.contentItems[index].classList.remove('is-left');
    };
    TabsContainer.prototype.removeDirectionRight = function (index) {
        this.contentItems[index].classList.remove('is-right');
    };
    TabsContainer.prototype.addDirectionLeft = function (index) {
        this.contentItems[index].classList.add('is-left');
    };
    TabsContainer.prototype.addDirectionRight = function (index) {
        this.contentItems[index].classList.add('is-right');
    };
    TabsContainer.prototype.addAnimation = function (index) {
        this.contentItems[index].classList.add('is-animating');
    };
    TabsContainer.prototype.removeAnimation = function (index) {
        this.contentItems[index].classList.remove('is-animating');
    };
    TabsContainer.prototype.resetDirections = function (index) {
        this.removeDirectionLeft(index);
        this.removeDirectionRight(index);
    };
    TabsContainer.prototype.setCurrentActiveItem = function (index, noAnimation) {
        this.addActiveItem(index);
        if (!noAnimation) {
            this.toggleTabItemAnimation(index);
        }
    };
    TabsContainer.prototype.removeLastActiveItem = function (index, noAnimation) {
        this.removeActiveItem(index);
        if (!noAnimation) {
            this.toggleTabItemAnimation(index);
        }
    };
    TabsContainer.prototype.toggleTabItemAnimation = function (index) {
        var _this = this;
        if (isInternetExplorer()) {
            // Internet explorer 11 and Edge doesn't go correctly into
            // transitionend event handler. Because of this, this IE hack
            // is inserted. Take care of the setTimeout timer (it must be
            // a value after css transition ends).
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = window.setTimeout(function () {
                _this.removeAnimation(index);
            }, 1001);
        }
        else {
            var me_1 = this;
            this.contentItems[index].addEventListener('transitionend', function handler(e) {
                me_1.removeAnimation(index);
                if (e.currentTarget) {
                    e.currentTarget.removeEventListener(e.type, handler);
                }
            });
        }
        this.addAnimation(index);
    };
    return TabsContainer;
}());
export { TabsContainer };
;
